module.exports = __webpack_public_path__ + "img/person-skiing-nordic.e18e8e30.svg";